import { PayloadAction } from '../../../store.model';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Sort, SortOrder } from '../../grid';
import { INITIAL_MAX_ROWS } from '../fixture/initial-max-rows';
import { createNextGridState } from '../function/create-next-grid-state.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../landing.action';
import { defaultState, LandingState } from '../landing.state';
import { GridType } from '../model/grid-type.model';

import { ResetGrid } from './reset-grid.action';

export function resetGridReducer(
    state: LandingState,
    action: PayloadAction<ActionType.EVAL_LANDING__RESET_GRID, ResetGrid>,
): LandingState {
    const nextState: LandingState = { ...state };
    try {
        const dState = defaultState();
        const ngo = createNextGridState(action.payload.grid, state, nextState);

        let nso: Sort = null;
        switch (action.payload.grid) {
            case GridType.FOR_ME:
                nso = dState.forMe.sortOptions;
                break;
            case GridType.BY_ME:
                nso = dState.byMe.sortOptions;
                break;
            case GridType.FOR_MY_TEAM:
                nso = dState.forMyTeam.sortOptions;
                break;
        }

        let nextFilteredRows = sortRows(ngo.rows, nso);

        ngo.showAllEnabled = nextFilteredRows.length > INITIAL_MAX_ROWS;

        nextFilteredRows = nextFilteredRows.slice(0, INITIAL_MAX_ROWS);

        ngo.filteredRows = nextFilteredRows;
        ngo.selectedFilterOptions = [];
        ngo.sortOptions = nso;
        ngo.showAll = false;

        // To manually trigger create table when resetting grid
        ngo.rows = [...ngo.rows];
    } catch {}

    return nextState;
}
